import { render, staticRenderFns } from "./ClassroomTopBar.vue?vue&type=template&id=bef7849c&scoped=true&"
import script from "./ClassroomTopBar.vue?vue&type=script&lang=js&"
export * from "./ClassroomTopBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef7849c",
  null
  
)

export default component.exports